import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import {
  collapseNonSelfAverage,
  selfAverage,
  type PerspectiveAverageEntry,
} from '@/core/models/perspective-analysis'

export const useSkillAnalysis = <T extends { perspectives: ReadonlyArray<PerspectiveAverageEntry> }>(
  skills: MaybeRefOrGetter<ReadonlyArray<T>>,
) => {
  const allSkills = computed(() => {
    return toValue(skills).map((skill) => {
      const othersAverage = collapseNonSelfAverage(skill.perspectives)
      const self = selfAverage(skill.perspectives)

      let reality: number | null = null
      if (othersAverage != null) {
        reality = othersAverage
      } else if (self != null) {
        reality = self
      }

      return { ...skill, average: reality }
    })
  })

  return {
    allSkills,
  }
}
